import React from 'react'
import logo from './images/logo.png'

export default class Welcome extends React.Component {
  constructor() {
    super()
    this.state = {
      url: 'https://lbapi.silvanhagen.com/'
    }
  }
  render() {
    return <div className="app Welcome">
      <div className="branding">
        <img src={logo} />
      </div>
      <p>Welcome to LiveBlog, let&apos;s get started!</p>
      <form
        className="site-select"
        onSubmit={e => {e.preventDefault(), this.props.onConnect(this.state.url)}}
      >
        <input
          type="url"
          required
          value={this.state.url}
          placeholder="Your WP API Site URL with /"
          onChange={e => this.setState({url:e.target.value})}
        />
        <button className="primary">Connect</button>
      </form>
    </div>
  }
}

Welcome.propTypes = {
  onConnect: React.PropTypes.func.isRequired
}



/** WEBPACK FOOTER **
 ** ./src/Welcome.js
 **/